import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RiArrowDownSLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";

import NavLanguageSelect from "../NavLanguageSelect";
import NavProjectSelect from "../NavProjectSelect";

import { NAV_OPTIONS } from "../../../utils/optionUtils";

import { styles } from "./style";

const NavList = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const [mouseOverItem, setMouseOverItem] = useState(undefined);

  useEffect(() => {
    setMouseOverItem(undefined);
  }, [location]);

  const handleCloseMenu = () => {
    setMouseOverItem(undefined);
  };

  return (
    <Box sx={styles.navListContainer}>
      {Array.from(NAV_OPTIONS).map(([key, value], index) => {
        const isMouseOverItem = mouseOverItem === index;

        if (value.ITEMS.length > 0) {
          return (
            <Box
              key={key}
              onMouseEnter={() => setMouseOverItem(index)}
              onMouseLeave={() => setMouseOverItem(undefined)}
              sx={
                isMouseOverItem
                  ? styles.navOptionActive
                  : styles.navOptionInactive
              }
            >
              <Typography sx={styles.navText}>{t(value.LABEL)}</Typography>
              <RiArrowDownSLine
                size={"0.8em"}
                style={{
                  transform: isMouseOverItem
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  // transition: "all 0.2s ease-in-out",
                }}
              />

              <NavProjectSelect
                handleCloseMenu={handleCloseMenu}
                items={value.ITEMS}
                open={isMouseOverItem}
              />
            </Box>
          );
        } else {
          return (
            <Link
              key={key}
              onMouseEnter={() => setMouseOverItem(index)}
              onMouseLeave={() => setMouseOverItem(undefined)}
              to={value.PATH}
              style={
                isMouseOverItem
                  ? styles.navOptionActive
                  : styles.navOptionInactive
              }
            >
              <Typography sx={styles.navText}>{t(value.LABEL)}</Typography>
            </Link>
          );
        }
      })}
    </Box>
  );
};

export default NavList;
